<template>
  <section class="download">
    <b-container>
      <b-row class="justify-content-center">
        <b-col cols="10" md="8" lg="6">
          <p class="download__description body-1">
            For full installation instructions, please visit
            <a
              class="link download__description__link--high-contrast"
              target="_blank"
              rel="noreferrer"
              href="https://github.com/AdobeXD/xd-to-flutter-plugin"
              aria-label="Visit Github.com in a new tab"
            >
              GitHub
            </a>
          </p>
          <h2 class="download__title heading-1">Download XD to Flutter</h2>
          <div class="download__actions">
            <a
              class="action action--fill"
              href="https://adobe.com/go/xd_to_flutter"
              target="_blank"
              rel="noreferrer"
              aria-label="Visit adobe.com in a new tab"
            >
              Download
            </a>
            <a
              class="action action--border"
              href="https://github.com/AdobeXD/xd-to-flutter-plugin"
              target="_blank"
              rel="noreferrer"
              aria-label="Visit github.com in a new tab"
            >
              Github
            </a>
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="11" md="8" lg="6">
          <div class="ratings">
            <h3 id="star-rating" aria-label="4.8 out of 5 stars" class="ratings__title heading-0">4.8/5</h3>
            <div class="ratings__icons">
              <b-icon
                class="ratings__icons__item"
                v-for="i in 5"
                :key="i"
                icon="star-fill"
                alt="rating, 4.8 out of 5 stars"
              />
            </div>
            <p class="ratings__subtitle heading-2">Based on 318 ratings<br>(Aug 18, 2021)</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  export default {
    name: "Download",
    methods: {
      visitGithub() {
        window.open(
          "https://github.com/AdobeXD/xd-to-flutter-plugin",
          "_blank"
        );
        return false;
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../variables";

  .download {
    margin-bottom: pxToRem(96);

    &__title {
      margin-bottom: pxToRem(48);
    }

    &__actions {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-wrap: wrap;
      margin-bottom: pxToRem(96);

      &__item {
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
          color: $body-2;
          margin: pxToRem(8) 0;
        }
      }

      .action {
        margin: pxToRem(8);
        text-align: center;
        &--fill{
          &:hover {
            color: $white;
          }
        }
        &:hover {
          text-decoration: none;
        }
      }
    }

    &__description {
      color: $white;
      text-align: center;
      margin-bottom: pxToRem(96);
      &__link--high-contrast {
        color: #6D9BFF;
      }
    }

    .ratings {
      background: $white;
      box-shadow: 0px 0px 10px 0px rgba(0, 7, 15, 0.15);
      border-radius: 20px 20px 20px 0px;
      text-align: center;
      padding: pxToRem(32);

      &__title {
        color: $title;
        margin-bottom: pxToRem(24);
      }
      &__subtitle {
        color: $body-3;
        margin-bottom: pxToRem(24);
      }
      &__icons {
        margin-bottom: pxToRem(16);
        &__item {
          color: $accent;
          width: 40px;
          height: 40px;
          margin: 0 pxToRem(4);
        }
      }
      &__opinion {
        color: $body-3;
        margin-bottom: pxToRem(8);
      }
    }
  }
</style>
